<template>
  <Head :title="session.title" />

  <div class="layout-beamer" :class="{ paused: isPaused }">
    <div class="backdrop"></div>

    <div class="container-wrapper">
      <div class="container">
        <header class="main">
          <div class="logo">
            <h1>
              <Link href="/game">
                <span>{{ appTitle }}</span>
              </Link>
            </h1>
          </div>

          <div class="status">
            <button type="button" class="fullscreen" @click.prevent="toggle">
              {{ $t('fullscreen') }}
            </button>
            <HeaderRound />
          </div>
        </header>

        <div class="main-wrapper">
          <slot />
        </div>
      </div>
    </div>
  </div>

  <Toaster :expand="true" />
</template>
<script setup lang="ts">
import { Head, Link, usePage } from '@inertiajs/vue3'
import { useFullscreen } from '@vueuse/core'
import { computed } from 'vue'
import { Toaster } from 'vue-sonner'

import { setThemeColor } from '/@front:composables/useThemeColor'
import type { PageProps } from '/@front:types/shared'

const { toggle } = useFullscreen()

import HeaderRound from './partials/HeaderRound.vue'

setThemeColor('#3e2723')

const page = usePage<PageProps>()
const appProps = computed(() => page.props.app)
const appTitle = computed(() => appProps.value.title)
const session = computed(() => page.props.session)

const isPaused = computed(() => session.value.roundStatus.value === 'paused')
</script>

<style src="/@front:css/layouts/beamer.css"></style>
